import { combineReducers } from 'redux';
import types from './types';

const isAuthenticated = (state = false, action) => {
  switch (action.type) {
    case types.DO_LOGIN:
      return true;
    case types.DO_LOGOUT:
      return false;
    default:
      return state;
  }
};

//初期情報
const initInfo = (state = [], action) => {
  switch (action.type) {
    case types.SET_INIT_INFO:
      return action.initInfo;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isAuthenticated,
  initInfo
});
export default reducer;
